import { FeeCalculatorRenderFieldConfig } from "@models/platform-analysis/entities/steps/fee";
import { memo } from "react";
import { useToggle } from "react-use";
import { FeeCalculatorVisibilityTracker } from "../../trackers/visibility-tracker";

type Props = {
  fieldConfig: FeeCalculatorRenderFieldConfig;
  disabled?: boolean;
};
export const FeeCalculatorRenderedFieldWrapper = memo(
  ({ fieldConfig, disabled }: Props) => {
    const { renderConditions, component: RenderComponent } = fieldConfig;

    const [shouldRender, toggleFieldVisibility] = useToggle(false);

    const handleOnVisibilityChange = (isVisible: boolean) => {
      if (isVisible === shouldRender) return;
      toggleFieldVisibility(isVisible);
    };

    return (
      <>
        <FeeCalculatorVisibilityTracker
          renderConditions={renderConditions}
          onVisibilityChange={handleOnVisibilityChange}
        />

        {shouldRender && (
          <RenderComponent fieldConfig={fieldConfig} disabled={disabled} />
        )}
      </>
    );
  },
);
